import Vue from 'vue';
import config from '@/config';
import store from '@/store';
import * as AuthService from '@/modules/authentication/services/authenticationService';

async function doRefreshToken(): Promise<void> {
  // Check if user is already logged in
  if (Vue.$cookies.isKey(config.security.jwtRefreshCookie)) {
    try {
      const tokenResponse = await AuthService.refreshToken(Vue.$cookies.get(config.security.jwtRefreshCookie));

      if (tokenResponse.data.access_token !== undefined && tokenResponse.data.refresh_token !== undefined) {
        store.dispatch('authentication/decodeAndUpdate', tokenResponse.data.access_token);
        Vue.$cookies.set(config.security.jwtRefreshCookie, tokenResponse.data.refresh_token);
      }
    } catch (err) {
      Vue.$cookies.remove(config.security.jwtRefreshCookie);
      store.commit('authentication/setJwtToken', null);
      store.commit('authentication/setDecodedJwtToken', null);
      window.location.href = AuthService.buildLogoutLink();
    }
  }
}

export { doRefreshToken };
